<p-table 
[value]="assemblies" 
dataKey="BAID" editMode="row" 
>
    <ng-template pTemplate="header">
        <tr>
            <th *ngIf="userAccessService.binderEditAccess()" style="width: 50px;"></th>
            <th style="min-width: 0;">Description</th>
            <th style="width: 150px; white-space: nowrap;">Price</th>
            <!-- <th style="width: 100px;">Quantity</th>
            <th style="width: 100px;">Total</th> -->
            <th *ngIf="userAccessService.binderAssembliesEditAccess() && showButtonCell(categoryId)" style="width: 120px;"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-last="last" let-assembly let-editing="editing" let-ri="rowIndex" let-index="rowIndex">
        <tr 
        [pEditableRow]="assembly" 
        [pReorderableRow]="index" 
        [attr.id]="'assembly-' + assembly.BAID" 
        [ngClass]="{'last-row-style border-round-bottom' : last}">
            <td *ngIf="userAccessService.binderEditAccess()" style="width: 50px;">
                <span class="pi pi-bars" pReorderableRowHandle></span>
            </td>
            <td style="min-width: 0;">
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <app-rich-text-editor [(ngModel)]="assembly.Description" [height]="'170px'"></app-rich-text-editor>
                    </ng-template>
                    <ng-template pTemplate="output">
                    <div [innerHTML]="assembly.Description"></div>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- <td class="smallCol align-top">
              
            </td> -->
            <td class="smallCol align-top price-cell" style="width: 150px; vertical-align: top;">
                <div style="display: flex; flex-direction: column; gap: 0.375rem;">
                    <div style="display: block;">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div style="display: flex; flex-direction: column; gap: 0.25rem;">
                                    <label class="text-xs text-color-secondary" style="font-weight: 500;">Quantity</label>
                                    <p-inputnumber pInputText [(ngModel)]="assembly.Quantity" required styleClass="w-full"/>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div class="price-label-grid">
                                    <span class="text-xs text-color-secondary price-label" style="font-weight: 500;">Qty:</span>
                                    <span>{{assembly.Quantity}}</span>
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </div>
                    <div style="display: block;">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div style="display: flex; flex-direction: column; gap: 0.25rem;">
                                    <label class="text-xs text-color-secondary" style="font-weight: 500;">Price</label>
                                    <p-inputnumber pInputText [(ngModel)]="assembly.Price" required styleClass="w-full"/>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div class="price-label-grid">
                                    <span class="text-xs text-color-secondary price-label" style="font-weight: 500;">Price:</span>
                                    <span>{{assembly.Price | currency}}</span>
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </div>
                    <div class="price-label-grid" style="margin-top: 0.25rem;">
                        <span class="text-xs text-color-secondary price-label" style="font-weight: 500;">Total:</span>
                        <span class="font-semibold">{{assembly.Price*assembly.Quantity | currency}}</span>
                    </div>
                </div>
            </td>
            <!-- <td class="smallCol align-top">
              <div class="flex gap-2">
                {{assembly.Price*assembly.Quantity | currency}}
              </div>
          </td> -->
            <td *ngIf="userAccessService.binderAssembliesEditAccess() && showButtonCell(assembly.CategoryID)" class="smallCol align-top">
                <div class="flex align-items-center justify-content-center gap-2">
                    <button *ngIf="!editing" pButton pRipple type="button" icon="pi pi-copy" (click)="copyAssembly(assembly)" pTooltip="Copy assembly to clipboard" tooltipPosition="left" class="p-button-rounded p-button-text"></button>
                    <button pTooltip="Edit Engineering assembly" tooltipPosition="top" [disabled]="!userAccessService.binderEditAccess() && !userAccessService.binderAssembliesEditAccess()" *ngIf="!editing && assembly.Type === 'F'" pButton pRipple type="button" icon="pi pi-pencil" (click)="showEngineering()" class="p-button-rounded p-button-text"></button>
                    <button pTooltip="Edit assembly" tooltipPosition="top" [disabled]="!checkAccess(assembly)" *ngIf="!editing && assembly.Type !== 'F'"  pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(assembly)" class="p-button-rounded p-button-text"></button>
                    <button pTooltip="Delete assembly" tooltipPosition="right" [disabled]="!checkAccess(assembly,true)" *ngIf="!editing" pButton pRipple type="button" icon="pi pi-trash" (click)="confirmDeleteAssembly(assembly)" style="color: red" class="p-button-rounded p-button-text"></button>
                    <button pTooltip="Save assembly" tooltipPosition="left" *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(assembly)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
                    <button pTooltip="Cancel edit" tooltipPosition="right" *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(assembly, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>